import { eraseCookie } from '../components/common/Cookie';

export function clearLocalStorage(arr) {
  if (Array.isArray(arr)) {
    arr.forEach(function(element) {
      localStorage.removeItem(element);
    });
  } else {
    localStorage.removeItem(arr);
  }
}
export function clearCookie(arr) {
  if (Array.isArray(arr)) {
    arr.forEach(function(element) {
      eraseCookie(element);
    });
  } else {
    eraseCookie(arr);
  }
}
